import * as Yup from 'yup';
import { ptShort } from 'yup-locale-pt';

Yup.setLocale(ptShort);

const ValidationSchema = Yup.object().shape({
  contract_id: Yup.string().required('Selecione um modelo de contrato').nullable(),
  contacts: Yup.array()
    .required('Selecione ao menos 1 contato')
    .min(1)
    .max(10)
    .nullable(),
});

const decodeHtmlEntities = str => {
  if (!str) return '';

  const textarea = document.createElement('textarea');

  textarea.innerHTML = str;

  return textarea.value;
};

const extractCustomVariables = content => {
  if (!content) return [];

  const regex = /\[(.*?)\]/gu;
  const matches = content.match(regex) || [];

  const variables = [...new Set(matches)]
    .map(match => {
      const variable = match.replace(/^\[|\]$/g, '');
      return decodeHtmlEntities(variable);
    })
    .filter(
      variable =>
        variable &&
        !variable.includes('!supportLists') &&
        !variable.includes('endif') &&
        !variable.includes('!supportLineBreakNewLine'),
    );

  return variables;
};

// Extract custom variables with their types
const extractCustomVariablesWithTypes = content => {
  if (!content) return [];

  const regex = /\[(.*?)\]/gu;
  const matches = content.match(regex) || [];

  const variables = [...new Set(matches)]
    .map(match => {
      const variable = match.replace(/^\[|\]$/g, '');
      const decodedVariable = decodeHtmlEntities(variable);

      const parts = decodedVariable.split('|').map(part => part.trim());

      return {
        name: parts[0],
        type: parts.length > 1 ? parts[1].toUpperCase() : 'TEXTO',
        fullName: decodedVariable,
      };
    })
    .filter(
      variable =>
        variable.name &&
        !variable.name.includes('!supportLists') &&
        !variable.name.includes('endif') &&
        !variable.name.includes('!supportLineBreakNewLine'),
    );

  return variables;
};

export { ValidationSchema, extractCustomVariables, extractCustomVariablesWithTypes };
